import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { filter, isUndefined } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd'

const scanTypes = [{
  label: "IAST", 
  value: "IAST"
}, {
  label: "SCA", 
  value: "SCA"
}, {
  label: "SAST", 
  value: "SAST"
}];

const initialFormValues = {
  product: undefined,
  subProduct: undefined,
  environment: undefined,
};

function ContrastSecurityMappingForm({disableProjectFields = false, ...props}, ref) {
    const [projects, setProjects] = useState(() => {
      if (props.record) {
        const { applicationId , applicationName } = props.record;
        const applicationIdArray = applicationId.split(',');
        const applicationNameArray = applicationName.split(',');
        
        return  applicationIdArray.map((id, index) => ({id, index: applicationNameArray[index]}))
      }
      return {};
    });
    const [initialValues] = useState(() => {
      if (props.record) {
        return [];
      }
      return [{ ...initialFormValues, scanType: ["SCA","IAST"] }];
    });
    const [form] = Form.useForm();

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects)
    }).catch(() => {
      message.error('Problem fetching organization');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { applicationId , applicationName } = config;
    // setOrganisation(organisationId)
    return ({
      applicationId: applicationId?.split(','),
      applicationName: applicationName?.split(','),
      scanType: config.scanType ? config.scanType.split(",") : [],
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
}, []);

  const getExtraFieldsData = (config) => {
    const { applicationId } = config;
    const selectedProject = filter(projects, project => applicationId.includes(project.id)).map(project => project.name)
    return ({
      applicationId: applicationId.join(),
      applicationName: selectedProject.join(),
      scanType: config.scanType ? config.scanType.join() : "",
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  };

  const extraFields = useMemo(() => ([
    {
      name: 'applicationId',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      label: 'Application',
      disabled: disableProjectFields,
      options:projects,
      required: true,
      loading:isUndefined(projects),
    },
    {
      name: "scanType",
      colSpan: "12",
      type: FieldTypes.MULTI_SELECT,
      label: "Scan Type",
      options: scanTypes,
    }
  ]), [projects, disableProjectFields]);

  return (
    <GenericMappingForm
      {...props}
      form={form}
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      formDefaultValues={initialValues}
    />
  )
}



export default forwardRef(ContrastSecurityMappingForm)
